$(document).ready(function(){
	
	$('.feature-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:false,
		pagination:false,  dots: true,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:3
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:5
	        }
	    }
	}); 
	 
});
